



























import Vue from 'vue'
import {Component, Mixins, Prop, Ref} from 'vue-property-decorator'
import {ActiveInject} from "@/support/reactive"
import AnalyticsEmitterMixin
    from "@/design-system/foundation/AnalyticsProvider/AnalyticsEmitterMixin"
import {
    AcquireFirstFocus, AcquireLastFocus,
    AcquireNextFocus,
    AcquirePreviousFocus
} from "@/design-system/utilities/FocusHelper"

/**
 * @status stable
 * @published 4.6.2
 * @changelog 4.6.2 Published.
 * @changelog 4.12.0 Add danger option.
 * @changelog 4.17.0 Update visuals.
 * @changelog $next Add disabled state.
 */
@Component({})
export default class JdsDropdownMenuItem extends Mixins(AnalyticsEmitterMixin) {
    @Prop() icon!: string
    @Ref() itemEl!: HTMLElement
    @Prop({type: Boolean, default: false}) disabled!: boolean
    @Prop({type: Boolean, default: false}) danger!: boolean
    @ActiveInject({from: 'jds.dropdown-menu.bus', default: null}) bus!: Vue

    handleClick(e: MouseEvent) {
        if (this.disabled) {
            return;
        }
        this.$emit('click', e)
        if (this.bus) {
            this.bus.$emit('dismiss')
            this.$analytics('click')
        }
    }

    handleHotkeys(e: KeyboardEvent) {
        if (this.disabled) {
            return;
        }
        if (e.key === 'ArrowDown') {
            AcquireNextFocus(this.itemEl.closest('[role=menu]'), this.itemEl)
            e.preventDefault()
        }
        if (e.key === 'ArrowUp') {
            AcquirePreviousFocus(this.itemEl.closest('[role=menu]'), this.itemEl)
            e.preventDefault()
        }
        if (e.key === 'Home') {
            AcquireFirstFocus(this.itemEl.closest('[role=menu]'))
            e.preventDefault()
        }
        if (e.key === 'End') {
            AcquireLastFocus(this.itemEl.closest('[role=menu]'))
            e.preventDefault()
        }
    }

    get classes() {
        return {
            'jdsc-dropdown-menu-item--danger': this.danger,
            'jdsc-dropdown-menu-item--disabled': this.disabled
        }
    }
}
